module.exports = __webpack_public_path__ + "static/media/lottery_mobile_bg.37b96af1.png";